import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HttpClientWrapper {
  constructor(private http: HttpClient) {}

  get(url: string, params?: HttpParams): Promise<any> {
    return lastValueFrom(this.http.get(url, { params }));
  }

  post(url: string, body: any, params?: HttpParams): Promise<any> {
    return lastValueFrom(this.http.post(url, body, { params }));
  }

  put(url: string, body: any, params?: HttpParams): Promise<any> {
    return lastValueFrom(this.http.put(url, body, { params }));
  }

  delete(url: string, params?: HttpParams): Promise<any> {
    return lastValueFrom(this.http.delete(url, { params }));
  }
}
